<template lang="pug">
g-data-table.confirmationTable(
  :items="pagination.data",
  :options.sync="options",
  :server-items-length="pagination.total",
  show-select,
  single-expand,
  v-model="selected",
  v-bind="{ headers, loading }",
)
  template(v-slot:item.action="{ item }")
    template(v-if="get(item, 'process.entity', null)")
      router-link(
        v-if="item.task.type != 'Email' && item.task.type != 'Call'",
        style="text-decoration: none",
        :to="generateLink(item)"
      )
        v-icon(small) mdi-eye

  //- Override with blank span will remove the select-all checkbox
  template(v-slot:header.data-table-select="{item, headers}")
    span

  template(v-slot:item.assignee="{ item }")
    v-autocomplete(
      v-if="item.entity != null && item.entity._Entity == 'Shipment'",
      :label="(item.shipment.assignee||{}).fullName",
      :value="(item.shipment.assignee||{}).id",
      :items="getFilteredUsers(item)",
      item-text="fullName",
      item-value="id",
      return-object,
      :disabled="item.shipment.assigneeId != null",
      @input="changeAssigned($event, item)",
    )
  template(v-slot:item.data-table-select="{ item }")
    v-checkbox(
      v-if="item.task.type === 'Email' || item.task.type === 'Call'"
      @change="checkChange($event, item)")
  template(v-slot:item.entity.externalId="{ item }")
    div {{ get(item, `${getProcessEntityPath(item)}.externalId`) }}
  template(v-slot:item.entity.status.name="{ item }")
    div {{ get(item, `${getProcessEntityPath(item)}.status.name`) }}
  //-- ORIGIN
  template(v-slot:item.entity.partyFrom.name="{ item }")
    div {{ getOriginAttribute(item, getProcessEntityPath(item), 'name') + ' - [' + getOriginAttribute(item, getProcessEntityPath(item), 'countryCode') + '] '}}
  //-- DESTINATION
  template(v-slot:item.entity.partyTo.name="{ item }")
    div {{ getDestinationAttribute(item, getProcessEntityPath(item), 'name') + ' - [' + getDestinationAttribute(item, getProcessEntityPath(item), 'countryCode') + '] '}}

  template(v-slot:top)
    v-row.table__title
      v-col.h2.primary--text {{ $t(customTitle) }}
    v-row.table__top
      v-col.py-0
        app-entity-search(
          v-if="!loadingCriteria",
          :criteria="routeCriteria",
          @pagination="setPagination",
          :loads="loads",
          :entity="entity",
          :rowsPerPage="options.itemsPerPage || null"
          :wheres="pagination.where",
          @changeInitial="changeInitial"
        )
      v-col.pt-4(cols="auto", v-if="selectedType != null")
        g-btn.h8(
            v-if="selectedType === 'Email' || selectedType ==='Call'",
            color="primary",
            @click="completeAction(selectedType)",
          ) {{ $t('Common.complete') }}
        v-dialog(
          v-else-if="isResponsibilityOrderLine",
          v-model="dialog",
          max-width="600"
        )
          template(v-slot:activator="{ on }")
            g-btn.h8(
              color="primary",
              v-on="on",
              @click="loadTemplates",
            ) {{ $t('Common.complete') }}
          v-card
            v-card-title {{ $t('PendingTasks.executeTasks') }}
            v-card-text
              v-autocomplete(
                :disabled="loading"
                :label="$t('PendingTasks.selectAnActionTemplate')"
                v-model="template",
                :items="templates",
                item-text="name",
                item-value="uid"
              )
          v-card
            v-card-title {{ $t('PendingTasks.emailPreview') }}
            v-card-text {{ $t('PendingTasks.executeTasks') }}
              div.mx-n3(v-show="simulation.body != null")
                v-row
                  v-col(cols="12")
                    v-text-field(label="Subject", v-model="simulation.subject")
                v-row
                  v-col(cols="6")
                    v-text-field(label="From", disabled, v-model="simulation.from")
                  v-col(cols="6")
                    v-text-field(@keydown.enter="pushEmailAndClear('to', $event)", :rules="emailRules", label="To ~")
                    v-chip(v-for="(t, i) in simulation.to", close, @click:close="simulation.to.splice(i, 1)") {{t}}
                v-row
                  v-col(cols="6")
                    v-text-field(@keydown.enter="pushEmailAndClear('cc', $event)", :rules="emailRules", label="CC ~")
                    v-chip(v-for="(t, i) in simulation.cc", close, @click:close="simulation.to.splice(i, 1)") {{t}}
                  v-col(cols="6")
                    v-text-field(@keydown.enter="pushEmailAndClear('bcc', $event)", :rules="emailRules", label="BCC ~")
                    v-chip(v-for="(t, i) in simulation.bcc", close, @click:close="simulation.to.splice(i, 1)") {{t}}
                v-row
                  v-col(cols="12")
                    div(ref="email_body", v-html="simulation.body", contenteditable="true")
            v-card-actions
              v-btn(text, color="error", @click="cancel") {{ $t('Common.cancel') }}
              v-btn(text, :disabled="!template || loading", @click="execute") {{ $t('PendingTasks.loadEmailAndPreview') }}
              v-btn(text, :disabled="(!simulation.body && !simulation.markdown) || loading", @click="sendEmail") {{ $t('Common.send') }}
</template>

<style lang="scss" scoped>
.g-data-table .row.table__top {
  flex-grow: 0;
}

.dialog__close {
  position: absolute;
  right: 15px;
  top: 15px;
}

.g-data-table {
  ::v-deep .v-data-table__expanded__content {
    box-shadow: none;
    background: var(--v-background-base);
    td {
      padding: 20px 30px;
      border-width: 2px !important;
      border-color: var(--v-primary-base) !important;
      border-style: solid none !important;

      .entity-display {
        background-color: var(--v-grisClair-base) !important;
      }
    }
  }
}
</style>

<script>
import axios from 'axios';
import get from 'lodash/get';
import find from 'lodash/find';
import camelCase from 'lodash/camelCase';
import keys from 'lodash/keys';

export default {
  name: 'PendingTasks',
  props: {
    customWhere: {
      type: Array,
      default: () => ([])
    },
    customTitle: {
      type: String,
      default: () => ("PendingTasks.pendingTasks")
    }
  },
  data: () => ({
    loading: false,
    options: {},
    selected: [],
    // Added wheres here for initial pagination
    // sent also to entity search
    pagination: {
      data: [],
      where: []
    },
    users: [],
    // Same loads as endpoint call on load()
    loads: [
      'Task',
      'Responsable',
      'Shipment.Status',
      'Shipment.PartyFrom',
      'Shipment.PartyTo',
      'Shipment.Assignee',
      'Order.Status',
      'Order.PartyFrom',
      'Order.PartyTo',
      'OrderLine.Status',
      'OrderLine.CollectionPoint',
      'OrderLine.DeliveryPoint',
      'Process',
    ],
    dialog: false,
    stateOpen: 'Open',
    template: null,
    templates: [],
    simulation: { body: null, from: null, to: [], cc: [], bcc: []},
    routeCriteria: [],
    loadingCriteria: false,
    urbs: []
  }),
  watch: {
    options: {
      handler(options) {
        this.load(options);
      }
    },
    selected: {
      handler() {
        //If Select all items
        if(this.selected.length == this.pagination.pageSize)
          this.removeQuoteResponsibilities()
        if (this.selected.length > 0 && this.selectedType == this.quoteTask)
          return this.pagination.data = this.pagination.data.filter(d => d.id == this.selected[0].id);
        return this.load();
      }
    }
  },
  computed: {
    headers() {
      return [
        { text: '', value: 'data-table-expand' },
        { text: this.$t('PendingTasks.actions'), value: "action", sortable: false },
        { text: this.$t('PendingTasks.externalId'), value: "entity.externalId" },
        { text: this.$t('PendingTasks.status'), value: "entity.status.name" },
        { text: this.$t('PendingTasks.originParty'), value: "entity.partyFrom.name" },
        { text: this.$t('PendingTasks.destinationParty'), value: "entity.partyTo.name" },
        { text: this.$t('PendingTasks.process'), value: "process.name" },
        { text: this.$t('PendingTasks.task'), value: "task.name" },
        { text: this.$t('PendingTasks.type'), value: "task.type" },
        { text: this.$t('PendingTasks.deadline'), value: "deadLine", type: 'DateTime' },
        { text: this.$t('PendingTasks.asignee'), value: "assignee", width: '240px' },
        { text: this.$t('PendingTasks.responsible'), value: "responsable.fullName" },
      ]
    },
    emailPattern () {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    },
    quoteTask() {
      return 'QUOTE';
    },
    isResponsibilityOrderLine() {
      if(this.selected[0] != null)
        return this.selected[0].orderLineId != null
      return false;
    },
    emailRules () {
      return [
        v => !v || this.emailPattern.test(v) || this.$t('PendingTasks.emailMustBeValid')
      ];
    },
    selectedType () {
      if (this.selected.length > 0)
        return this.selected[0].task.type;
      return null;
    },
    wheres() {
      var w = [
        'x => x.State = "' + this.stateOpen +  '" && x.Task.Type != null && Task.Type.Length > 0',
        'x => x.Task.Type != "CONF"',
        'x => x.Task.Type != "ASN"'
      ];
      //Add all filters when an OrderLine is selected
      if (this.selected.length > 0) {
        let type = this.selected[0].task.type;
        w.push(`x => x.Task.Type == "${type}"` + this.getFilterByEntity())
      }
      w = w.concat(this.customWhere);
      return w
    },
    entity() {
      return this.$findEntity('Responsibility');
    },
    hasAdminRole() {
      return this.urbs.map(x => x.role != null ? x.role.name : "").includes("ADMIN");
    }
  },
  methods: {
    get,
    getProcessEntityPath(item) {
      return camelCase(get(item, 'process.entity', 'task'))
    },
    getOriginAttribute(item, entity, attribute) {
      if (!entity) return '';
      if (entity === 'orderLine') return get(item, `${entity}.collectionPoint.${attribute}`);
      if (entity === 'shipment') return get(item, `${entity}.partyFrom.${attribute}`);
      if (entity === 'order') return get(item, `${entity}.partyFrom.${attribute}`);
      return '';
    },
    getDestinationAttribute(item, entity, attribute) {
      if (!entity) return '';
      if (entity === 'orderLine') return get(item, `${entity}.deliveryPoint.${attribute}`);
      if (entity === 'shipment') return get(item, `${entity}.partyTo.${attribute}`);
      if (entity === 'order') return get(item, `${entity}.partyTo.${attribute}`);
      return '';
    },
    getFilterByEntity(){
      if(this.selected[0] == null) return '';
      if(this.selected[0].orderLineId != null) return ' && x.orderLineId != null';
      if(this.selected[0].orderId != null) return ' && x.orderId != null';
      if(this.selected[0].shipmentId != null) return ' && x.shipmentId != null';
    },
    removeQuoteResponsibilities(){
      if(this.pagination.data.filter(d => d.task.type == this.quoteTask).length > 1){
        this.pagination.data = this.pagination.data.filter(d => d.task.type != this.quoteTask);
        this.selected = this.selected.filter(d => d.task.type != this.quoteTask);
      }
    },
    pushEmailAndClear (prop, event) {
      if (this.emailPattern.test(event.target.value)) {
        this.simulation[prop].push(event.target.value);
        event.target.value = null; // clear text field
      }
    },
    cancel () {
      this.dialog = false
      this.clearTemplate()
    },
    clearTemplate () {
      this.simulation = { body: null };
      this.template = null;
      this.selected = [];
      this.$refs['email_body'].innerHTML = null;
    },
    checkChange(event, item) {
      if(event) {
        this.selected.push(item);
      }else {
        this.selected.splice(this.selected.indexOf(item), 1);
      }
    },
    async changeAssigned(evt, item) {
      try {
        this.loading = true;
        let shipmentSaved = await axios.post(`assignUser/${item.shipment.uid}/${evt.externalId}`);
        //Refresh index only if status change is successful
        if(shipmentSaved) {
          await this.load();
        } else {
          this.loading = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async complete () {
      this.loading = true;
      try {
        let result = await axios.post(`responsibilities/complete`,
        {
          responsibilitiesUids: this.selected.map(r => r.uid)
        });
        this.selected = [];
        this.load();
      } catch (err) { console.error(err); }
      this.loading = false;
    },
    getNextRespAttribute(item, attr) {
      const responsabilities = get(item, 'responsibilities');
      const nextResponsibilityId = get(item, 'nextResponsibility.id');
      const found = find(responsabilities, ['id', nextResponsibilityId]);
      if (found) return get(found, `task.${attr}`);
      return null;
    },
    async sendEmail() {
      // console.log(this.$refs["email_body"]);
      this.loading = true;
      try {
        let result = await axios.post(`orderLines/SendPendingEmails`,
        {
          responsibilitiesUids: this.selected.map(r => r.uid),
          actionData: {
            ...this.simulation,
            body: this.$refs["email_body"].innerHTML
          }
        });
        this.dialog = false;
        this.clearTemplate();
        this.load();
      } catch (err) { console.error(err); /* leaves dialog open */ }
      this.loading = false;
    },
    async execute() {
      this.loading = true;
      this.$refs["email_body"].innerHTML = ""
      let simulationRaw = { body: null, from: null, to: [], cc: [], bcc: []};
      let entity = {
        linesUids: this.selected.map(r => r.orderLine.uid)
      };
      try {
        simulationRaw = { ...((
          await axios.post(`simulations/actionTemplate/${this.template}/render/OrderLinesPendingEmail`, entity)
        ).data) };
      } catch (err) { console.error(err); /* leave dialog open */}
      this.simulation = simulationRaw;
      if(this.simulation.isRazor != null && this.simulation.isRazor == true){
        this.$refs["email_body"].innerHTML = this.simulation.body;
      } else {
        this.$refs["email_body"].innerHTML = this.simulation.markdown;
      }
      this.loading = false;
    },
    setPagination(event) {
      //For Pending Task table, always have the same pagination.where
      event.where =  this.pagination.where
      this.pagination = event;
    },
    getPagination(options = null, where = null) {
      options = options || this.options;
      if (!keys(options).length) return;
      // console.log('OPTS ', options)
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: options.sortBy[0] ? options.sortBy[0] : 'deadLine',
          desc: options.sortDesc[0] ? options.sortDesc[0] : false ,
          where: where,
        }
      };
    },
    async loadTemplates() {
      this.loading = true;
      if (this.templates == null || this.templates.length == 0) {
        try {
          const templates = get(
            await axios.get("actionTemplate", {
              params: { withoutGlobalBusinessScope: true, pageSize: 250, where: ['TemplateType = "EMAIL"', 'PendingTask = true'] }
            }),
            "data.data"
          );
          this.templates = templates ? templates : [];
        } catch (e) {
          console.error(`[ERROR LOADING TEMPLATES] ${e}`);
        }
      }
      this.loading = false;
    },
    async completeAction(selectedType) {
      this.loading = true;
      if(selectedType == this.quoteTask){
        if(this.selected[0].shipment != null){
          this.$router.push(`/${this.$scope()}/Quote/Add?s=${this.selected[0].shipment.externalId}`);
        }
      }
      this.loading = false;
    },
    async load(options = null) {
      try {
        this.loading = true;
        const pagination = this.getPagination(options, this.wheres);

        if (this.$route.params.criteria) {
          try {
            this.loadingCriteria = true;
            this.routeCriteria = [this.$route.params.criteria];
            var criteria = this.$route.params.criteria && this.$route.params.criteria.entity == this.entity.name ? { Where: [this.$route.params.criteria.value] } : null;
            pagination.params = {...pagination.params, ...criteria};
          } catch(e) {
            console.log(this.$cleanString(e))
          } finally {
            this.$nextTick(() => {
              this.loadingCriteria = false;
            });
          }
        }

        let endpoint = this.$fetchLoad(
          "Responsibilities",
          true,
          'Task',
          'Responsable',
          'Shipment.Status',
          'Shipment.PartyFrom',
          'Shipment.PartyTo',
          'Shipment.Assignee',
          'Order.Status',
          'Order.PartyFrom',
          'Order.PartyTo',
          'OrderLine.Status',
          'OrderLine.CollectionPoint',
          'OrderLine.DeliveryPoint',
          'Process',
        );

        const paginationResult = (await axios.get(endpoint, pagination)).data;
        this.pagination = paginationResult;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    changeInitial(event) {
      this.$router.replace({ path: '/' }, () => {
        this.$router.replace({ name: 'home', params: { scope: this.$scope(), criteria: null }});
      });
    },
    getFilteredUsers(item) {
      var bsId = item.entity ? item.entity.businessScopeId : "";
      if (this.hasAdminRole) {
        return this.users.filter(x => x.userRoleBusinessScopes.map(u => u.businessScopeId).includes(bsId));
      }
      else {
        return this.users.filter(x => x.id == this.$store.state.user.user.id && x.userRoleBusinessScopes.map(u => u.businessScopeId).includes(bsId));
      }
    },
    async getUsers() {
      try {
        this.users = (await axios.get(`Users`, { params: { pageSize: -1, withoutGlobalBusinessScope: true,load: ['UserRoleBusinessScopes'] } })).data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getRoles() {
      var userId = this.$store.state.user.user.id;
      var bsId = window.localStorage.getItem("BusinessScopeId");
      try {
        this.urbs = (await axios.get(`UserRoleBusinessScopes`, { params: { withoutGlobalBusinessScope: true, load: ['Role'], where: [`x => x.userId =="${userId}"`, `x => x.businessScopeId == "${bsId}"`] } })).data.data;
      } catch (error) {
        console.log(error);
      }
    },
    generateLink(item) {
      const processEntity = get(item, 'process.entity');
      const baseRoute = `/${this.$scope()}/${processEntity}`;
      const portal = get(item, 'entity.portal');
      const uid = get(item, `${this.getProcessEntityPath(item)}.uid`);
      const quoteFragment = item.task.type === 'QUOTE' ? '#Quote' : '';
      const workstationQuery = { workstation: true };
      if (portal) {
        return {
          path: `${baseRoute}/portal/${portal}/${uid}/edit${quoteFragment}`,
          query: workstationQuery
        };
      }
      return {
        path: `${baseRoute}/${uid}/edit${quoteFragment}`,
        query: workstationQuery
      };
    }
  },
  async created() {
    this.getRoles();
    this.getUsers();
  },
  async mounted() {
    this.$store.commit('SET_ERRORS', { });
  }
};
</script>
